<template>

<core-dropdown class="input" trigger="manual" v-on:forceClose="is.expanded = false" :expanded="is.expanded" v-click-outside="onOutsideClick">

	<core-button v-on:click.native="onToggleClick" :text="text" theme="filter" :caret="true" :iconLeft="true" :icon="($isMobile) ? 'pen-to-square' : false" class="input-icon" />
	
	<core-dropdown-list :title="text" :expanded="is.expanded" :caret="true" theme="filter" class="input-options" align="left" type="button" v-propagation v-on:close="is.expanded = false">

		<slot></slot>

	</core-dropdown-list>

</core-dropdown>

</template>

<script>

import vClickOutside from 'v-click-outside'

export default {

	directives: {
		clickOutside: vClickOutside.directive
	},

	props: [
		'filter', 'page', 'text'
	],
	
	data: function() {

		return {
			is: {
				expanded: false,
				copying: false,
				exporting: false
			}
		}

	},

	created: function() {

		this.$pubsub.$on('presets.open', this.onOutsideClick.bind(this))
		this.$pubsub.$on('plays.expand', this.onOutsideClick.bind(this))
		this.$pubsub.$on('collection.expand', this.onOutsideClick.bind(this))

	},

	beforeDestroy: function() {

		this.$pubsub.$off('presets.open', this.onOutsideClick.bind(this))
		this.$pubsub.$off('plays.expand', this.onOutsideClick.bind(this))
		this.$pubsub.$off('collection.expand', this.onOutsideClick.bind(this))

	},

	computed: {

		can: function() {

			return this.$store.getters['service/select/can']

		}

	},

	methods: {

		onExportCSVClick: function(e) {

			e.stopPropagation()

			this.is.exporting = true

			this.$store.dispatch('service/select/export/csv').then(function() {

				this.is.exporting = false

			}.bind(this))

		},

		onExportClipboardClick: function(e) {

			e.stopPropagation()

			this.is.copying = true

			this.$store.dispatch('service/select/export/clipboard').then(function() {

				this.is.copying = false

			}.bind(this))

		},

		onTagsClick: function(e) {

			e.stopPropagation()

			this.$pubsub.$emit('open.modal', 'tagManage')

			this.onOutsideClick()

		},

		onToggleClick: function() {

			this.is.expanded = !this.is.expanded

		},

		onOutsideClick: function() {

			this.is.expanded = false

		}

	}

}

</script>

<style scoped>

.input {
	padding: 0px 0px;
}

.input-options-item {
	white-space: nowrap;
	padding: 8px 15px 8px 15px;
	cursor: pointer;
	font-size: 12px;
	line-height: 16px;
}

.input-options-item .fa {
	font-size: 12px;
	width: 20px;
}

.is-desktop .input-options-item:hover {
	color: #fff;
	font-weight: 400;
}

.input-options-item.is-active {
	color: #fff;
	font-weight: 600;
}

</style>
